import {
  TaskRefFragment,
  TasksDocument,
  TasksQuery,
  withNewStandardListSuspenseHook,
} from '@spotify/confidence-graphql';

const useTasksSuspenseImpl = withNewStandardListSuspenseHook<
  TasksQuery,
  TaskRefFragment,
  'tasks'
>(TasksDocument, 'tasks', {
  fragmentName: 'TaskRef',
});

export const useTasksSuspense = useTasksSuspenseImpl;
